// extracted by mini-css-extract-plugin
export default {"mainDiv":"Signup_mainDiv__0E7jI","signupButton":"Signup_signupButton__DqUX7"};